import { IconButton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { memo, useCallback, useMemo } from 'react';
import type { MouseEvent } from 'react';

import { VisibilityOff } from '@/assets/icons';
import { StyledTooltip } from '@/helpers/styles';

import { LayerServiceFactory } from '../service/LayerServiceFactory';
import { useUpdateLayerUserPreference } from '../hooks/useUpdateLayerUserPreference';
import { FDDM_LAYER_DEFINITIONS } from '../layerTree';

const UnhideEverythingButtonComponent = () => {
  const { t } = useTranslation('interface');
  const layerSvc = useMemo(() => LayerServiceFactory.getInstance().createLayerService(), []);
  const { updateVisibilityModes } = useUpdateLayerUserPreference();

  const handleClick = useCallback(
    (event: MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();
      layerSvc.showAllElements();
      updateVisibilityModes(FDDM_LAYER_DEFINITIONS.map(layer => layer.name), 'auto');
    },
    [layerSvc, updateVisibilityModes],
  );

  return (
    <StyledTooltip
      style={{ marginLeft: 'auto' }}
      title={t('interface:layers.show_everything', 'Show Everything')}
      placement='bottom'
    >
      <IconButton sx={{ padding: 0, marginRight: 1 }} onClick={handleClick}>
        <VisibilityOff />
      </IconButton>
    </StyledTooltip>
  );
};

export const UnhideEverythingButton = memo(UnhideEverythingButtonComponent);
